







import {Component, Prop, Vue} from 'vue-property-decorator';
import GoalBooklet from "@/models/goal-booklet";
import FilterBooklet from "@/models/filter-booklet";

@Component({
    components: {
    },
})
export default class BookletView extends Vue {

    @Prop()
    public goalid!: string;

    @Prop()
    public id!: string;

    get bookletsList() {
        return this.$store.state.booklets;
    }


    get goalBooklet(): FilterBooklet|null {

        const booklets = this.bookletsList;

        if (booklets && booklets.length) {
            return booklets.find((filterBooklet: FilterBooklet) => {
                return filterBooklet.id.toString() === this.id.toString();
            })
        }
        return null;
    }
}
